import { useTranslation } from 'react-i18next';
import { Flex, Heading, Button, DropdownMenu } from '@radix-ui/themes';

const ContentCalendarHeader = ({ onAddHighlight, onAddBroadcast }) => {
  const { t } = useTranslation('campaigns');

  return (
    <Flex justify="between" align="center" height="42px">
      <Heading size="6" m="0">
        {t('plan.title')}
      </Heading>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button size="3">
            <i className="fa-solid fa-plus" />
            {t('plan.add')}
            <DropdownMenu.TriggerIcon />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end">
          <DropdownMenu.Item onClick={onAddHighlight}>
            <i className="fa-regular fa-star" />
            {t('plan.addHighlight')}
          </DropdownMenu.Item>
          <DropdownMenu.Item onClick={onAddBroadcast}>
            <i className="fa-regular fa-paper-plane-top" />
            {t('plan.addBroadcast')}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </Flex>
  );
};

export default ContentCalendarHeader;
